import {
  Iata,
  PlatformConfig,
  PlatformThemeId,
  OpCoClassName,
} from '@reward-platform/shared-schemas'
import { isProduction, isStaging } from '../envChecks'

type OpCoMetaConfig = {
  id: OpCoClassName
  name: string
  localeOptions: string[]
  defaultLocale: string
  // marketOptions: string[]
  defaultMarket: string
  /**
   * to allow for Op Co to be enabled for the avios.com build
   * if true, will be used in validating cookie set by avios.com
   */
  isAviosEnabled: boolean
  /**
   * value of Op Co theme key to use for the whitelabel build
   */
  whitelabelTheme: PlatformThemeId
}

const shouldEnableMultiOpCo = !isStaging() && !isProduction()

export const OP_CO_META_CONFIGS: Record<Iata, OpCoMetaConfig> = {
  BA: {
    id: 'british_airways',
    name: 'British Airways',
    localeOptions: ['en-GB', 'en-US'],
    defaultLocale: 'en-GB',
    defaultMarket: 'GB',
    whitelabelTheme: 'british_airways',
    isAviosEnabled: true,
  },
  EI: {
    id: 'aer_lingus',
    name: 'Aer Lingus',
    localeOptions: ['en-GB', 'en-US'],
    defaultLocale: 'en-GB',
    defaultMarket: 'GB',
    whitelabelTheme: 'aer_lingus',
    // enabled for lower environments for testing
    isAviosEnabled: shouldEnableMultiOpCo,
  },
  VY: {
    id: 'vueling',
    name: 'Vueling',
    localeOptions: ['es-ES', 'en-GB'],
    defaultLocale: 'es-ES',
    defaultMarket: 'ES',
    whitelabelTheme: 'vueling',
    isAviosEnabled: false,
  },
  // IB: {
  //   id: 'iberia',
  //   name: 'Iberia',
  //   localeOptions: ['es-ES', 'en-GB'],
  //   defaultLocale: 'es-ES',
  //   defaultMarket: 'ES',
  //   whitelabelTheme: 'iberia',
  //   isAviosEnabled: false,
  // },
}

export const DEFAULT_OP_CO: Iata = 'BA'
export const DEFAULT_PLATFORM_THEME: PlatformThemeId = 'avios'

export const getOpCoMetaConfig = (iata: Iata): OpCoMetaConfig => OP_CO_META_CONFIGS[iata]

export const isOpCoEnabledForAvios = (iata: Iata) => OP_CO_META_CONFIGS[iata].isAviosEnabled

export const getDefaultPlatformConfig = (iata: Iata): PlatformConfig => {
  const metaConfig = OP_CO_META_CONFIGS[iata]
  return {
    opCo: iata,
    locale: metaConfig.defaultLocale,
    market: metaConfig.defaultMarket,
    theme: 'avios',
  }
}
